<template>
  <v-app>

    <v-app-bar app color="primary" dark clipped-left>
      <v-app-bar-nav-icon @click.stop="sidebarMenu = !sidebarMenu"></v-app-bar-nav-icon>

      <v-toolbar-title>
        Time Sync
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <span
        v-if="!$auth.loading&&$auth.isAuthenticated"
        class="mr-2"
      >
        {{$auth.user.name}}
      </span>

      <v-btn
        v-if="!$auth.loading&&!$auth.isAuthenticated"
        @click="login"
      >
        Login
      </v-btn>
      <v-btn
        v-if="!$auth.loading&&$auth.isAuthenticated"
        @click="logout"
      >
        Logout
      </v-btn>

    </v-app-bar>

    <v-navigation-drawer app v-if="sidebarMenu" dark clipped>
      <NavList :pages="pages"></NavList>

      <NavList
        v-if="!$auth.loading && $auth.isAuthenticated"
        :pages="authPages"
      ></NavList>
      <NavList
        v-if="!$auth.loading && $auth.isAuthenticated"
        :pages="adminPages"
      ></NavList>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

  </v-app>
</template>

<script>
import NavList from '@/components/NavList.vue';

export default {
  name: 'App',

  components: {
    NavList,
  },

  data: () => ({
    sidebarMenu: true,
    pages: [
      { title: 'Home', link: '/' },
    ],
    unauthPages: [
    ],
    authPages: [
      // { title: 'Profile', link: '/profile' },
      { title: 'Payroll', link: '/payroll' },
      { title: 'NoahFace', link: '/noahface' },
      { title: 'Alcomeasure', link: '/alcomeasureemails' },
      // { title: 'Events', link: '/events' },
      // { title: 'Visitors Forms', link: '/forms' },
      // { title: 'Timesheets', link: '/timesheets' }, // TODO: Show reactively
    ],
    adminPages: [
      // { title: 'Businesses', link: '/businesses' },
    ],
  }),

  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>
